// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForgotPassword-m_sOHssUcoHZHcOA4GA6pQ {
    margin: 1rem 0;
    text-align: center;
}

.ForgotPassword-m_JEKiJGPy3n65ZFntZLig {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.ForgotPassword-m_JEKiJGPy3n65ZFntZLig > div {
    margin: 1rem 0;
}

.ForgotPassword-m_Lw1ih_0V3bQ7CRU6UTiI {
    background-color: var(--pies-darkgrey);
    margin-right: 1rem;
}

.ForgotPassword-m_fzKvaJTVhTYFASHyyp9L {
    margin-top:2rem;
    text-align: center;
    font-size: .9rem;
}`, "",{"version":3,"sources":["webpack://./client/login/ForgotPassword/ForgotPassword.m.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".buttonContainer {\n    margin: 1rem 0;\n    text-align: center;\n}\n\n.resetPasswordForm {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.resetPasswordForm > div {\n    margin: 1rem 0;\n}\n\n.backButton {\n    background-color: var(--pies-darkgrey);\n    margin-right: 1rem;\n}\n\n.returnToLogin {\n    margin-top:2rem;\n    text-align: center;\n    font-size: .9rem;\n}"],"sourceRoot":""}]);
// Exports
export var buttonContainer = `ForgotPassword-m_sOHssUcoHZHcOA4GA6pQ`;
export var resetPasswordForm = `ForgotPassword-m_JEKiJGPy3n65ZFntZLig`;
export var backButton = `ForgotPassword-m_Lw1ih_0V3bQ7CRU6UTiI`;
export var returnToLogin = `ForgotPassword-m_fzKvaJTVhTYFASHyyp9L`;
export default ___CSS_LOADER_EXPORT___;
